export enum AccountType {
    cash = "Cash",
    accountsReceivable = "Accounts Receivable",
    inventory = "Inventory",
    otherCurrentAssets = "Other Current Assets",
    investments = "Investments",
    fixedAssets = "Fixed Assets",
    intangibleAssets = "Intangible Assets",
    otherAssets = "Other Assets",
    accountsPayable = "Accounts Payable",
    creditCards = "Credit Cards",
    payrollLiabilities = "Payroll Liabilities",
    shortTermLoans = "Short-Term Loans",
    otherCurrentLiabilities = "Other Current Liabilities",
    longTermLoans = "Long-Term Loans",
    otherLiabilities = "Other Liabilities",
    equity = "Equity",
    income = "Income",
    cogs = "COGS",
    operatingExpenses = "Operating Expenses",
    otherIncome = "Other Income",
    otherExpenses = "Other Expenses",
}

export enum AccountSubtype {
    cashOnHand = "Cash on Hand",
    bankAccount = "Bank Account",
    paymentProcessor = "Payment Processor",
    transferClearing = "Transfer Clearing",
    accountsReceivable = "Accounts Receivable",
    allowanceForBadDebts = "Allowance for Bad Debts",
    prepaidExpenses = "Prepaid Expenses",
    accruedRevenue = "Accrued Revenue",
    inventory = "Inventory",
    otherCurrentAssets = "Other Current Assets",
    usGovernmentObligations = "U.S. Government Obligations",
    taxExemptSecurities = "Tax-Exempt Securities",
    investments = "Investments",
    land = "Land",
    buildings = "Buildings",
    leaseholds = "Leaseholds",
    vehicles = "Vehicles",
    equipment = "Equipment",
    furnitureAndFixtures = "Furniture and Fixtures",
    furniture = "Furniture",
    otherFixedAssets = "Other Fixed Assets",
    accumulatedDepreciation = "Accumulated Depreciation",
    startupCosts = "Startup Costs",
    trademarksAndPatents = "Trademarks and Patents",
    goodwill = "Goodwill",
    otherIntangibleAssets = "Other Intangible Assets",
    accumulatedAmortization = "Accumulated Amortization",
    intercompanyReceivables = "Intercompany Receivables",
    employeeLoans = "Loans to Employees",
    loansToOwner = "Loans to Owner",
    loansToShareholders = "Loans to Shareholders",
    loansToPartners = "Loans to Partners",
    mortgageAndRealEstateLoans = "Mortgage and Real Estate Loans",
    securityDeposits = "Security Deposits",
    depletableAssets = "Depletable Assets",
    accumulatedDepletion = "Accumulated Depletion",
    otherLongTermAssets = "Other Long-Term Assets",
    accountsPayable = "Accounts Payable",
    creditCard = "Credit Card",
    creditCardClearing = "Credit Card Clearing",
    payrollPayable = "Payroll Payable",
    payrollAccount = "Payroll Account",
    lineOfCredit = "Line of Credit",
    shortTermLoans = "Short-Term Loans",
    currentMaturitiesOfLongTermDebt = "Current Maturities of Long-Term Debt",
    salesTaxPayable = "Sales Tax Payable",
    deferredRevenue = "Deferred Revenue",
    accruedExpenses = "Accrued Expenses",
    customerDeposits = "Customer Deposits",
    otherCurrentLiabilities = "Other Current Liabilities",
    longTermLoans = "Long-Term Loans",
    loansFromOwner = "Loans from Owner",
    loansFromShareholders = "Loans from Shareholders",
    loansFromPartners = "Loans from Partners",
    lessCurrentMaturitiesOfLongTermDebt = "Less Current Maturities of Long-Term Debt",
    intercompanyPayables = "Intercompany Payables",
    otherLiabilities = "Other Liabilities",
    contributions = "Contributions",
    distributions = "Distributions",
    capital = "Capital",
    commonStock = "Common Stock",
    additionalPaidInCapital = "Additional Paid-In Capital",
    dividends = "Dividends",
    retainedEarnings = "Retained Earnings",
    adjustmentsToShareholdersEquity = "Adjustments to Shareholders' Equity",
    costOfTreasuryStock = "Cost of Treasury Stock",
    revenue = "Revenue",
    refundsAndReturns = "Refunds and Returns",
    discountsAndAllowances = "Discounts and Allowances",
    cogsGoodsAndMaterials = "COGS - Goods and Materials",
    cogsLabor = "COGS - Labor",
    cogsOther = "COGS - Other",
    salariesAndWages = "Salaries and Wages",
    guaranteedPaymentsToPartners = "Guaranteed Payments to Partners",
    officersCompensation = "Officer's Compensation",
    contractLabor = "Contract Labor",
    salariesAndWagesClearing = "Salaries and Wages - Clearing",
    commissions = "Commissions",
    payrollTaxes = "Payroll Taxes",
    employeeBenefits = "Employee Benefits",
    retirementBenefits = "Retirement Benefits",
    advertisingAndMarketing = "Advertising and Marketing",
    computersAndElectronics = "Computers and Electronics",
    learningAndDevelopment = "Learning and Development",
    licensesAndPermits = "Licenses and Permits",
    propertyTaxes = "Property Taxes",
    entertainment = "Entertainment",
    insurance = "Insurance",
    internetAndPhone = "Internet and Phone",
    facilities = "Facilities",
    meals = "Meals",
    merchantAndBankFees = "Merchant and Bank Fees",
    loanFees = "Loan Fees",
    suppliesAndEquipment = "Supplies and Equipment",
    softwareAndSubscriptions = "Software and Subscriptions",
    officeExpenses = "Office Expenses",
    officeUtilities = "Office Utilities",
    legalAndProfessionalFees = "Legal and Professional Fees",
    rentAndLease = "Rent and Lease",
    travel = "Travel",
    vehicle = "Vehicle",
    otherOperatingExpenses = "Other Operating Expenses",
    rentalIncome = "Rental Income",
    interestIncome = "Interest Income",
    dividendIncome = "Dividend Income",
    rebateIncome = "Rebate Income",
    royaltyIncome = "Royalty Income",
    gainLossAssetDisposals = "Gain (Loss) Asset Disposals",
    otherIncome = "Other Income",
    interestExpense = "Interest Expense",
    depreciation = "Depreciation",
    amortization = "Amortization",
    depletion = "Depletion",
    finesAndPenalties = "Fines and Penalties",
    badDebts = "Bad Debts",
    donations = "Donations",
    otherExpense = "Other Expense",
    federalTaxes = "Federal Taxes",
    stateAndLocalTaxes = "State and Local Taxes",
    uncategorizedIncome = "Uncategorized Income",
    uncategorizedExpenses = "Uncategorized Expenses",
    commisions = "Commisions",
}

export enum AccountClass {
    assets = "Assets",
    liabilities = "Liabilities",
    equity = "Equity",
    income = "Income",
    expenses = "Expenses",
}

export enum BalanceSheetAccountClass {
    assets = AccountClass.assets,
    liabilities = AccountClass.liabilities,
    equity = AccountClass.equity,
}

export const BALANCE_SHEET_CLASS_MAP: Record<string, BalanceSheetAccountClass> =
    {
        [AccountClass.assets]: BalanceSheetAccountClass.assets,
        [AccountClass.liabilities]: BalanceSheetAccountClass.liabilities,
        [AccountClass.equity]: BalanceSheetAccountClass.equity,
    };

export function toBalanceSheetAccountClass(
    accountClass: string | null,
): BalanceSheetAccountClass | null {
    if (!accountClass) {
        return null;
    }
    return BALANCE_SHEET_CLASS_MAP[accountClass] ?? null;
}

export enum AccountSection {
    assets = "Assets",
    liabilitiesAndEquity = "Liabilities and Equity",
    currentAssets = "Current Assets",
    nonCurrentAssets = "Non-Current Assets",
    liabilities = "Liabilities",
    equity = "Equity",
}

export enum BalanceSheetDerivativeLines {
    netIncome = "Net Income",
    unclassified = "Balancing",
}

export enum DefaultCashBasisAccountCodes {
    cashOnHands = 100000,
    bankTransferClearing = 109900,
    paymentTransferClearing = 109901,
    accountsReceivable = 110000,
    allowanceForBadDebts = 119900,
    inventory = 120000,
    prepaidExpenses = 130000,
    accruedRevenue = 130100,
    otherCurrentAssets = 139900,
    usGovernmentObligations = 140000,
    taxExemptSecurities = 140100,
    investments = 140200,
    land = 150000,
    buildings = 150100,
    leaseholdImprovements = 150200,
    vehicles = 150300,
    equipment = 150400,
    furnitureAndFixturesAsset = 150500,
    otherFixedAssets = 159800,
    accumulatedDepreciation = 159900,
    startupCosts = 160000,
    trademarksAndPatents = 160100,
    goodwill = 160200,
    otherIntangibleAssets = 169800,
    accumulatedAmortization = 169900,

    // NOTE: intercompanyReceivables is within a dynamic type group
    // for now, we still map it based on the original account code as it's alawys first in its group
    // but in the future we should migrate to another form of unique key
    intercompanyReceivables = 190000,
    employeeLoans = 190100,
    loansToRelatedParties = 190200,
    mortgageAndRealEstateLoans = 190300,
    securityDeposits = 190400,
    depletableAssets = 190500,
    accumulatedDepletion = 190600,
    otherLongTermAssets = 199900,

    accountsPayable = 200000,
    creditCardClearing = 219900,
    payrollPayable = 220000,
    lineOfCredit = 230000,
    shortTermLoans = 230100,
    currentMaturitiesOfLongTermDebt = 239900,

    salesTaxPayable = 240000,
    deferredRevenue = 240100,
    accruedExpenses = 240200,
    customerDeposits = 240300,
    otherCurrentLiabilities = 249900,

    longTermLoans = 250000,
    loansFromRelatedParties = 250100,
    lessCurrentMaturitiesOfLongTermDebt = 259900,

    intercompanyPayables = 290000,
    otherLongTermLiabilities = 299900,
    revenue = 400000,
    refundsAndReturns = 401000,
    discountsAndAllowances = 402000,
    uncategorizedIncome = 499099,
    cogsGoodsAndMaterials = 500000,
    cogsLabor = 500100,
    cogsOther = 500200,
    salariesAndWages = 600000,
    contractLabor = 600100,
    commissions = 600300,
    salariesAndWagesClearing = 609900,
    payrollTaxes = 610000,

    employeeBenefits = 620000,
    retirementBenefits = 620100,

    advertisingAndMarketing = 700000,
    learningAndDevelopment = 701000,
    licensesAndPermits = 702000,
    propertyTaxes = 703000,
    entertainment = 704000,
    insuranceBusiness = 705000,
    insuranceOwnersPartnersOfficers = 705001,
    internetAndPhone = 706000,
    facilitiesRepairsAndMaintenance = 707000,
    facilitiesCleaningFees = 707001,
    facilitiesManagementFees = 707002,
    furnitureAndFixturesExpense = 708000,
    meals = 709000,
    mealsEmployeeCatering = 709001,
    merchantAndBankFees = 710000,
    suppliesAndEquipment = 711000,
    softwareAndSubscriptions = 712000,
    officeExpenses = 713000,
    officeUtilities = 714000,
    legalAndProfessionalFees = 715000,
    rentAndLease = 716000,
    travel = 717000,
    vehicle = 718000,
    vehicleLeases = 718001,
    vehicleParkingAndTolls = 718002,
    loanFees = 719000,
    otherOperatingExpenses = 799000,
    uncategorizedExpenses = 799099,

    rentalIncome = 800000,
    interestIncome = 801000,
    dividendIncome = 802000,
    rebateIncome = 803000,
    royaltyIncome = 804000,
    gainLossAssetDisposals = 848000,
    otherIncome = 849000,
    interestExpense = 850000,
    depreciation = 851000,
    amortization = 852000,
    depletion = 853000,
    finesAndPenalties = 854000,
    badDebts = 855000,
    donations = 856000,
    otherExpense = 899000,
    federalTaxes = 900000,
    stateAndLocalTaxes = 900100,
}
